import theme from '../../base';

const radioButton = {
  default: {
    bg: theme.colors.neutrals.white,
    border: theme.colors.neutrals.gray700,
    label: theme.colors.neutrals.gray700,
  },
  checked: {
    bg: theme.colors.blues.blue500,
    border: theme.colors.blues.blue500,
    foreground: theme.colors.blues.blue500,
  },
  disabled: {
    bg: theme.colors.neutrals.gray250,
    border: theme.colors.neutrals.gray500,
  },
  focus: {
    border: theme.colors.neutrals.white,
    offsetShadow: theme.colors.blues.blue300,
    insetShadow: theme.colors.neutrals.white,
  },
};

export default radioButton;
